const GoalsData = [
  {
    id: 1,
    emoji: '🏃‍♂️',
    title: 'Exercise regularly',
    desc: 'Exercise has been shown to improve mood, reduce stress and anxiety, and improve overall mental well-being.',
  },
  {
    id: 2,
    emoji: '🥦',
    title: 'Eat a healthy diet',
    desc: ' A balanced diet that includes a variety of fruits, vegetables, whole grains, and lean proteins can help improve mental health.',
  },
  {
    id: 3,
    emoji: '💤',

    title: 'Get enough sleep',
    desc: 'Adequate sleep is essential for good mental health. Lack of sleep can lead to irritability, difficulty concentrating and increased risk of depression and anxiety.',
  },
  {
    id: 4,
    emoji: '🧘‍♂️',
    title: 'Practice mindfulness',
    desc: 'Mindfulness is a mental state achieved by focusing one’s awareness on the present moment, while calmly acknowledging and accepting one’s feelings, thoughts, and bodily sensations.',
  },
  {
    id: 5,
    emoji: '🚫',
    title: 'Avoid drugs and alcohol',
    desc: 'Drugs and alcohol can have a negative impact on mental health. They can cause or worsen depression and anxiety, and lead to substance abuse disorders.',
  },
  {
    id: 6,
    emoji: '🧘‍♂️',
    title: 'Manage stress',
    desc: 'Learning stress management techniques, such as deep breathing, meditation, and progressive muscle relaxation, can help reduce stress and improve mental well-being.',
  },
  {
    id: 7,
    emoji: '👨‍⚕️',
    title: 'Seek professional help',
    desc: 'If you’re experiencing symptoms of mental illness, it’s important to seek professional help. A mental health professional can help you manage your symptoms and develop a treatment plan.',
  },
  {
    id: 8,
    emoji: '👨‍👩‍👧‍👦',
    title: 'Connect with others',
    desc: 'Social support is an important part of mental health. Spending time with friends and family can help you feel less isolated and improve your mood.',
  },
  {
    id: 9,
    emoji: '👍',
    title: 'Maintain a positive attitude',
    desc: 'Having a positive outlook can help you cope with stress and improve your overall mental health and well-being.',
  },
];

export default GoalsData;
